import { ENDPOINTS } from '../utils/endpoints';
import { getAPIwithToken, postAPIwithToken } from '../utils/fetchApi';
import type {
  SapSyncLogsResponse,
  SapSyncLogDetailResponse,
  SapSyncMetricsResponse,
  SapTestSftpResponse,
  SapGenericTriggerResponse,
} from '../types/sapSync';

export interface GetSapLogsParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  jobType?: string;
  direction?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

// Helper to construct query string
const buildQueryString = (params: Record<string, any>): string => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') {
      query.append(key, String(val));
    }
  });
  const qs = query.toString();
  return qs ? `?${qs}` : '';
};

// 1. Get SAP Sync KPI Metrics
export const getSapSyncMetricsAPI = async (): Promise<SapSyncMetricsResponse> => {
  return await getAPIwithToken<SapSyncMetricsResponse>(ENDPOINTS.SAP_METRICS);
};

// 2. Get SAP Sync Logs Data Table (Paginated, filtered)
export const getSapSyncLogsAPI = async (
  params: GetSapLogsParams = {}
): Promise<SapSyncLogsResponse> => {
  const qs = buildQueryString(params);
  return await getAPIwithToken<SapSyncLogsResponse>(`${ENDPOINTS.SAP_LOGS}${qs}`);
};

// 3. Get SAP Sync Log By ID
export const getSapSyncLogByIdAPI = async (
  id: string | number
): Promise<SapSyncLogDetailResponse> => {
  return await getAPIwithToken<SapSyncLogDetailResponse>(ENDPOINTS.SAP_LOG_BY_ID(id));
};

// 4. Retry Failed / Partial Log Run
export const retrySapSyncLogAPI = async (
  id: string | number
): Promise<SapGenericTriggerResponse> => {
  return await postAPIwithToken<SapGenericTriggerResponse>(ENDPOINTS.SAP_RETRY_LOG(id), {});
};

// 5. Trigger Daily Orders Sync outbound to SAP
export const triggerSapDailyOrdersSyncAPI = async (): Promise<SapGenericTriggerResponse> => {
  return await postAPIwithToken<SapGenericTriggerResponse>(ENDPOINTS.SAP_SYNC_DAILY_ORDERS, {});
};

// 6. Trigger Inbound SFTP Scan
export const triggerSapInboundSyncAPI = async (): Promise<SapGenericTriggerResponse> => {
  return await postAPIwithToken<SapGenericTriggerResponse>(ENDPOINTS.SAP_TRIGGER_INBOUND_SYNC, {});
};

// 7. Trigger Generic Job (e.g. INBOUND_INVOICES, OUTBOUND_ORDERS, etc.)
export const triggerSapJobAPI = async (
  jobType: string,
  extraPayload?: Record<string, any>
): Promise<SapGenericTriggerResponse> => {
  return await postAPIwithToken<SapGenericTriggerResponse>(ENDPOINTS.SAP_TRIGGER_JOB, {
    jobType,
    ...(extraPayload || {}),
  });
};

// 8. Test SFTP Connection and list remote files
export const testSapSftpListFilesAPI = async (): Promise<SapTestSftpResponse> => {
  return await getAPIwithToken<SapTestSftpResponse>(ENDPOINTS.SAP_TEST_LIST_FILES);
};
